T.Quotes = Class(
	/**
	 * @lends {T.Quotes#}
	 */
	{
		__NAME: 'T.Quotes',

		__construct( quotes, type, par = null ) {
			this.quotes = quotes;
			this.par = par || {};

			let classNames = ['testimonials'];
			let video = null;
			if( this.par.youtubeVideoId ) {
				video = mkE({
					tag: 'iframe',
					src: `https://www.youtube-nocookie.com/embed/${this.par.youtubeVideoId}?rel=0`,
					attr: {
						frameborder: 0,
						allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
						allowfullscreen: ''
					}
				});
				classNames.push('w-video');
			}

			this.node = mkE({
				tag: 'div',
				className: classNames.join(' '),
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get(`testimonials.${type}.title`)
							},
							D.Lang.exists(`testimonials.${type}.underline`) ? {
								tag: 'p',
								className: 'underline',
								text: D.Lang.get(`testimonials.${type}.underline`)
							} : '',
							{
								tag: 'div',
								className: 'inner-container',
								els: [
									video,
									this._sliderNode = mkE({
										tag: 'div',
										className: 'glide',
										style: {
											position: 'relative'
										},
										els: [
											{
												tag: 'div',
												className: 'glide__track',
												style: {
													overflow: 'hidden'
												},
												attr: {
													"data-glide-el": 'track'
												},
												els: [
													this._quotesNode = mkE({
														tag: 'div',
														className: 'glide__slides',
														style: {
															display: 'flex'
														}
													}),
													{
														tag: 'div',
														className: 'glide__arrows',
														style: {
															position: 'absolute'
														},
														attr: {
															"data-glide-el": "controls"
														},
														els: [
															{
																tag: 'button',
																className: 'glide__arrow glide_arrow--left',
																attr: {
																	"data-glide-dir": '<'
																}
															},
															{
																tag: 'button',
																className: 'glide__arrow glide_arrow--right',
																attr: {
																	"data-glide-dir": '>'
																}
															}
														]
													}
												]
											}
										]
									})
								]
							}
						]
					}
				]
			});

			if( this.par.videoSchemaMarkup ) {
				mkE({
					tag: 'script',
					attr: {type: 'application/ld+json'},
					text: JSON.stringify(this.par.videoSchemaMarkup)
				}).append(this.node);
			}

			this._draw();
		},

		_draw() {
			for( let i = 0, l = this.quotes.length; i < l; i++ ) {
				new T.Quotes.Quote(this.quotes[i], this.par).append(this._quotesNode);
			}
		},

		goTo( index ) {
			if( !this._slider ) {
				return;
			}
			this._slider.go('=' + index);
		},

		onShow() {
			D.onLoad('Glide', D.closure(this, this._initSlider));
		},

		_getSliderGap() {
			if( window.innerWidth < 1134 ) {
				return 12;
			} else {
				return 64;
			}
		},

		_getSliderPeek() {
			if( window.innerWidth < 1134 ) {
				const slideWith = 320;
				const preSlide = window.innerWidth <= 320 ? 0 : 16;
				const afterSlide = this.node.offsetWidth - this._getSliderPerView() * slideWith - preSlide;
				return {before: preSlide, after: afterSlide};
			} else {
				return 0;
			}
		},

		_getSliderPerView() {
			if( window.innerWidth < 1134 ) {
				const w = this._getSliderGap() + 320;
				return Math.floor(this.node.offsetWidth / w);
			} else if( this.par.youtubeVideoId ) {
				return 1;
			} else {
				return 3;
			}
		},

		_initSlider() {
			let sliderParams = {
				type: 'carousel',
				startAt: 0,
				gap: this._getSliderGap(),
				peek: this._getSliderPeek(),
				perView: this._getSliderPerView(),
				focusAt: 0,
				dragThreshold: false
			};
			if( this.quotes.length <= 3 ) {
				sliderParams.focusAt = 'center';
			}
			this._slider = new Glide(this._sliderNode, sliderParams);
			this._slider.on('resize', this._onSliderResize);
			this._slider.mount();
		},

		_onSliderResize() {
			this._slider.update({
				perView: this._getSliderPerView()
			});
		},

		onLeave() {
			if( this._slider ) {
				this._slider.destroy();
			}
		}
	},
	mkE.Base
);
T.Quotes.get = function ( type, par = null ) {
	let quotes = type ? D.QUOTES.filter(quote => {
		return quote.type === type && (quote.languages.length === 0 || quote.languages.includes(D.LANG))
	}) : D.QUOTES.filter(quote => quote.languages.length === 0 || quote.languages.includes(D.LANG));
	if( !quotes.length ) {
		return null;
	}
	return new T.Quotes(quotes, type, par);
};

T.Quotes.Quote = Class(
	/**
	 * @lends {T.Quotes.Quote#}
	 */
	{
		__construct( data, par ) {
			this.data = data;
			this.par = par;

			const noEventTitle = data.type === 'event' || this.par.noEventTitles;
			let text = D.Lang.get(`testimonials.${this.data.id}.quote`);
			this.node = mkE({
				tag: 'div',
				className: 'glide__slide',
				els: [
					{
						tag: 'a',
						className: 'testimonial',
						href: D.url(`/testimonials/${data.type}/?id=${data.id}`),
						els: [
							{
								tag: 'div',
								className: 'info',
								els: [
									{
										tag: 'div',
										className: 'event',
										text: noEventTitle ? '' : D.Lang.get(`testimonials.${this.data.id}.event`)
									},
									{
										tag: 'div',
										className: 'text ' + (text.length > 140 ? 'text-long' : ''),
										text: text
									},
									{
										tag: 'div',
										className: 'more',
										text: D.Lang.get('testimonials.read_more')
									}
								]
							},
							{
								tag: 'div',
								className: 'footer',
								els: [
									{
										tag: 'div',
										className: 'person',
										els: [
											{
												tag: 'div',
												els: [
													{
														tag: 'h4',
														text: D.Lang.get(`testimonials.${this.data.id}.name`)
													},
													{
														tag: 'div',
														className: 'position',
														text: D.Lang.get(`testimonials.${this.data.id}.position`)
													}
												]
											},
											{
												tag: 'img',
												className: 'image',
												loading: 'lazy',
												src: data.image
											}
										]
									}
								]
							}
						]
					}
				]
			});
		}
	},
	mkE.Base
);